
<n-slide-window *ngIf="pageReady"
    [visible]="windowVisible"
    [width]="isJa ? '8rem':'7rem'"
    (onHide)="close()">
    <n-header>
        <h1>{{i18n.upgrade}}</h1>
        <n-help-link key="storagesysUpgrade" *ngIf="!SWITCH.IS_SIMPLE_MODE"></n-help-link>
        <n-help-link key="simplifyInfo" *ngIf="SWITCH.IS_SIMPLE_MODE"></n-help-link>
    </n-header>

    <div class="choose">
        <!-- 热补丁 -->
        <div id="upgrade-choose-mode-hotpatch"
            (click)="showUpgradeEntry(UpgradeModeE.HotPatch)"
            class="choose-item">
            <div class="choose-item-text">
                <h3 class="choose-item-text-title">{{i18n.hotpachTitle}}</h3>

                <p>{{i18n.hotPatchDes}}</p>
            </div>

            <div class="choose-item-icon">
                <svg class="icon">
                    <use [attr.xlink:href]="'#app-icon-hotpatch'"></use>
                </svg>
            </div>
        </div>

        <!-- 系统升级 -->
        <div id="upgrade-choose-mode-system-upgrade"
            *ngIf="isShowSystemUpgrade"
            (click)="showUpgradeEntry(UpgradeModeE.System)"
            class="choose-item">
            <div class="choose-item-text">
                <h3 class="choose-item-text-title">{{i18n.systemUpgradeTitle}}</h3>

                <p>{{i18n.sysUpgradeDes}}</p>
            </div>

            <div class="choose-item-icon">
                <svg class="icon">
                    <use [attr.xlink:href]="'#app-icon-system-upgrade'"></use>
                </svg>
            </div>
        </div>
    </div>

<n-footer>
    <button id="upgrade-choose-mode-cancel-btn"
        nButton
        [label]="i18n.closeBtn"
        (click)="close()">
    </button>
</n-footer>
</n-slide-window>
